@if (!data) {
  <p class="no-data">
    Carregando...
  </p>
}

@if (data && !data.length) {
  <p class="no-data" [innerHtml]="mensagemSemDados">
  </p>
}

<div (window:resize)="setMaxheight($event)">
  <div class="table-overflow" [style]=" limitarAlturaMaxima ? 'max-height: ' + maxHeight + 'px' : ''">
    @if (data?.length) {
      <table mat-table [dataSource]="data" class="mat-elevation-z1" matSort (matSortChange)="sortBy($event)">
        @for (column of props; track column) {
          <ng-container matColumnDef="{{column}}">
            <th mat-header-cell *matHeaderCellDef [disabled]="isAction(column) || column === 'checkbox' || !getPermiteOrdenar(column)"
                    [mat-sort-header]="column" [ngClass]="{
                'w-acoes': isAction(column),
                'w-checkbox' : column === 'checkbox'
            }">
              @if (column === 'checkbox' && mostrarSelecionarTodos) {
                <mat-checkbox
                  (change)="selecionarTodosHandler($event.checked)" [checked]="todosSelecionados()">
                </mat-checkbox>
              }
              @if (column !=='checkbox') {
                {{isAction(column) ? getAcoesTitle() : column}}
              }
            </th>
                <td mat-cell *matCellDef="let item" [ngClass]="
            {
            'w-acoes': column === 'Ações',
            'w-checkbox' : column === 'checkbox'
            }" [ngStyle]="{ 'background-color': getCorLinha(item), 'color': getCorFonte(item)}">
              @if (column !== 'Ações') {
                @if (column ==='checkbox' && mostrarSelecionarItem) {
                  <mat-checkbox
                  (change)="emitirSelecionarItem(item, $event.checked)" [checked]="itemSelecionado(item)"></mat-checkbox>
                }
                @if (column !=='checkbox') {
                  <div [class]="getClasses(item, column)"
                    [title]="getTitle(item,column) || ''"
                    [matTooltip]="getToolTip(item, column)"
                    [matTooltipDisabled]="!hasTooltip(item, column)"
                    matTooltipPosition="below">
                    <div [ngClass]="{'multline': getMultiLinhas(column)}">
                      {{ getMask(item,column) ? (getValue(item,column) | mask: getMask(item,column)) : getValue(item,column) }}
                    </div>
                  </div>
                }
              } @else {
                @if (config.actions?.length === 1 && !esconder(item, config.actions[0])) {
                  <button mat-icon-button
                    (click)="config.actions[0].action(item)" [disabled]="desabilitar(item, config.actions[0])">
                    <mat-icon [color]="getCorIcone(item, config.actions[0])">{{config.actions[0].icone || "more_horiz"}}</mat-icon>
                  </button>
                }
                @if (config.actions?.length > 1 && !todasOpcoesEscondidas(item)) {
                  <button mat-icon-button
                    [matMenuTriggerFor]="actionsMenu" [matMenuTriggerData]="{item: item, config: config}">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                }
              }
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="props; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: props;"></tr>
      </table>
    }
  </div>
  @if (meta?.total) {
    <mat-paginator
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="meta!.qtdeRegistros"
      [pageIndex]="meta!.pagina! -1"
      [length]="meta!.total"
      (page)="handleMetaChanged($event)"
      [showFirstLastButtons]="true">
    </mat-paginator>
  }
</div>
<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    @for (action of config.actions; track action) {
      <div>
        @if (!esconder(item, action)) {
          <div>
            <button mat-menu-item (click)="action.action(item)" [disabled]="desabilitar(item, action)">
              <span>{{action.title}} </span>
            </button>
          </div>
        }
      </div>
    }
  </ng-template>
</mat-menu>
